import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const PhoneWrapper = styled.div`
  * {
    direction: rtl !important;
  }
  label {
    span {
      color: ${theme.colours.error};
      font-size: 15px;
    }
    p {
      font-family: ${theme.fonts.Medium};
      font-size: 14px;
      color: ${theme.colours.blackText};
      margin-bottom: 8px;
      &:lang(en) {
        text-align: left !important;
      }
      &:lang(ar) {
        text-align: right !important;
      }
    }
  }

  .mantine-Select-root.hasError .mantine-Select-input {
    border: 1px solid ${theme.colours.error} !important;
  }

  .hasError {
    .react-select__control {
      border: 1px solid ${theme.colours.error} !important;
      &:lang(ar) {
        border-left: none !important;
      }
      &:lang(en) {
        border-right: none !important;
      }
    }
  }

  .code-input {
    .react-select__control {
      width: 110px;
      max-width: 110px;
      height: 53px;
      background-color: transperant;
      border-radius: 0;
      border: 1px solid #ebebeb;
      border-inline-start: 0 !important;
      box-shadow: none !important;
      @media (max-width: 767px) {
        width: 100px;
        max-width: 100px;
      }
      border-top-left-radius: 14px;
      border-bottom-left-radius: 14px;
      .react-select__value-container {
        padding-block: 0;
        padding: 2px 7px;
        .react-select__placeholder {
          font-size: 14px;
        }
        .react-select__input-container {
          padding: 0;
          margin: 0;
        }
        .react-select__single-value {
          font-size: 14px;
        }
      }
    }
    .react-select__menu {
      font-size: 14px;
      width: 220px !important;
    }
    img {
      display: inline-block;
      width: 24px;
      height: 31px;
      vertical-align: middle;
      border-radius: 16px;
      margin-left: 4px;
    }
  }
  input {
    border-inline-end: 0 !important;
  }
  .phone_number {
    input {
      border-bottom-left-radius: 0 !important;
      border-top-left-radius: 0 !important;
      height: 40px;
      text-align: left !important;
    }
  }
`;
